// The combat drawer ticker and the combat modal. Extracted from App.tsx
// (ROADMAP 7.14); renders in the same DOM position.

import type { ComponentProps } from 'react';
import type { useSettings } from '../settings/useSettings.js';
import { CombatDrawerTicker, CombatModal } from '../ui/CombatOverlay/index.js';
import type { useCombatView } from './useCombatView.js';

type CombatOverlayMode = ReturnType<typeof useSettings.getState>['combatOverlayMode'];

interface MatchCombatOverlaysProps {
  mode: CombatOverlayMode;
  view: ReturnType<typeof useCombatView>;
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  selectedIndex: number;
  setSelectedIndex: ComponentProps<typeof CombatModal>['onSelectFight'];
}

export function MatchCombatOverlays({
  mode,
  view,
  modalOpen,
  setModalOpen,
  selectedIndex,
  setSelectedIndex,
}: MatchCombatOverlaysProps) {
  const { drawerSummary, localCapital, combatFights, combatRoundsByFight } = view;
  return (
    <>
      {mode !== 'off' ? (
        <CombatDrawerTicker
          activeCount={drawerSummary.activeCount}
          nearFights={drawerSummary.nearFights}
          distantCount={drawerSummary.distantCount}
          localCapital={localCapital}
          onClick={() => {
            if (mode === 'modal+drawer') {
              setSelectedIndex(0);
              setModalOpen(true);
            }
          }}
        />
      ) : null}
      {mode === 'modal+drawer' && modalOpen ? (
        <CombatModal
          fights={combatFights}
          roundsByFight={combatRoundsByFight}
          selectedIndex={selectedIndex}
          onSelectFight={setSelectedIndex}
          onMinimize={() => setModalOpen(false)}
          onClose={() => setModalOpen(false)}
        />
      ) : null}
    </>
  );
}
